import defprotocol from '../defprotocol'
import Function from '../types/Function'

const Concatable = defprotocol({
  concat: Function
})

export default Concatable
